import { HeaderSection } from '@/components/Common/HeaderSection/HeaderSection';
import { NavigationTabs } from '@/components/Common/NavigationTabs/NavigationTabs';
import TopLevelSectionLayout from '@/layouts/TopLevelSectionLayout/TopLevelSectionLayout';
import { AssignKamDialog } from './AssignKamDialog/AssignKamDialog';
import { useBuyerProfileViewController } from './BuyerProfileViewController';

export function BuyerProfile() {
  const { uiState, actions } = useBuyerProfileViewController();

  return (
    <TopLevelSectionLayout>
      <HeaderSection
        title={uiState.title}
        showReturn
        sx={{ px: { xs: '10px', md: '0px' } }}
        moreActions={uiState.moreActions}
        onMoreActionsClicked={actions.onMoreOptionSelected}
      />
      {uiState.buyerId && (
        <NavigationTabs
          links={[
            {
              to: `/admin/buyer/${uiState.buyerId}`,
              label: 'Negocio y Contacto',
            },
            {
              to: `/admin/buyer/${uiState.buyerId}/address`,
              label: 'Direcciones de Entrega',
            },
            {
              to: `/admin/buyer/${uiState.buyerId}/billing`,
              label: 'Facturación y Pagos',
            },
          ]}
        />
      )}
      <AssignKamDialog
        open={uiState.assignKamOpen}
        handleClose={actions.closeAssignKamDialog}
      />
    </TopLevelSectionLayout>
  );
}
